import api from "./axiosInstance";

/**
 * Invoice API Service
 * Handles all invoice related API calls
 * Backend: RecurringInvoiceController at /api/v1/recurring-invoices
 */

export const invoiceApi = {
  /**
   * Get all invoices
   * GET /api/v1/recurring-invoices
   */
  getAllInvoices: (params = {}) => {
    return api.get("recurring-invoices", { params });
  },

  /**
   * Get invoice by ID
   * GET /api/v1/recurring-invoices/{id}
   */
  getInvoiceById: (id) => {
    return api.get(`recurring-invoices/${id}`);
  },

  /**
   * Create new invoice
   * POST /api/v1/recurring-invoices
   */
  createInvoice: (data) => {
    return api.post("recurring-invoices", data);
  },

  /**
   * Update invoice
   * PUT /api/v1/recurring-invoices/{id}
   */
  updateInvoice: (id, data) => {
    return api.put(`recurring-invoices/${id}`, data);
  },

  /**
   * Delete invoice by ID
   * DELETE /api/v1/recurring-invoices/{id}
   */
  deleteInvoice: (id) => {
    return api.delete(`recurring-invoices/${id}`);
  },

  /**
   * Get draft invoices
   * GET /api/v1/recurring-invoices/draft
   */
  getDraftInvoices: () => {
    return api.get("recurring-invoices/draft");
  },

  /**
   * Create draft invoice
   * POST /api/v1/recurring-invoices/draft
   */
  createDraftInvoice: (data) => {
    return api.post("recurring-invoices/draft", data);
  },

  /**
   * Download invoice PDF
   * GET /api/v1/recurring-invoices/{id}/pdf
   */
  downloadInvoicePdf: (id) => {
    return api.get(`recurring-invoices/${id}/pdf`, { responseType: 'blob' });
  },

  /**
   * Preview invoice PDF
   * GET /api/v1/recurring-invoices/{id}/pdf/preview
   */
  previewInvoicePdf: (id) => {
    return api.get(`recurring-invoices/${id}/pdf/preview`, { responseType: 'blob' });
  }
};

export default invoiceApi;
